angular.module('bmsApp.employeeAdditionalPaymentModule').factory('EmployeeAdditionalPaymentSvc', function ($rootScope, $q, $modal, notify, CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/employeeAdditionalPayment/index', params);
		},
		save: function (additionalPayment) {
			return CRUDSvc.post('api/employeeAdditionalPayment/save', additionalPayment);
		},
		delete: function (additionalPayment) {
			return CRUDSvc.get('api/employeeAdditionalPayment/delete/' + additionalPayment.id);
		},
		showSaveModal: function (additionalPayment) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/employee/employeeAdditionalPayment/templates/EmployeeAdditionalPaymentModal.html',
				controller: 'EmployeeAdditionalPaymentModalCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					additionalPayment: function () {
						return angular.copy(additionalPayment);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					notify({
						message: 'Additional payment saved successfully'
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});

			return modalInstance.result;
		}
	};

});
